// ВАЖНО: nukeWCStorage импортируется ПЕРВЫМ — его side-effect стирает
// stale WalletConnect-сторадж до того, как SDK успеет проинициализироваться.
import './utils/nukeWCStorage';
import './utils/walletConnectErrorGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {store} from "./store/store";
import './i18n';
import '@fontsource/open-sans';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
